import { request } from "../base/HTTP";
import HttpMethod from "../constants/HttpMethod";

export async function createYotiSession(id) {
    return await request('/api/yoti/session/' + id, {}, HttpMethod.POST);
}

export async function yotiSessionDone(data) {
    return await request('/api/yoti/done', data, HttpMethod.POST);
}